import React from 'react'

import { Button, Input, ModalBox, useModalContext } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import * as S from './EmailSendModal.styled'
import type { FormValues } from './EmailSendModal.types'
import { initialValues, validationSchema } from './consts'

export type EmailSendModalProps = {
  onSubmit: (values: FormValues) => void
}

export const EmailSendModal = ({ onSubmit }: EmailSendModalProps) => {
  const { close } = useModalContext()

  const formik = useFormik<FormValues>({
    initialValues,
    validationSchema,
    onSubmit,
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBox
        title="Send DNS records list via email"
        size="small"
        buttons={[
          <Button
            label="Send"
            appearance="primary"
            type="submit"
            disabled={!formik.isValid || !formik.dirty}
          />,
          <Button label="Cancel" appearance="secondary" onClick={close} />,
        ]}
        onClose={close}
      >
        <S.Description>
          Enter your email and we’ll send you a copy of the DNS records.
        </S.Description>
        <Input label="your@email.com" required {...formik.getFieldProps('email')} />
      </ModalBox>
    </form>
  )
}
